import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

import {IActionType} from "../../shared/model/action-type.model";
import {SERVER_API_URL} from "../../app.constants";
import {createRequestOption} from "../../shared/util/request-util";


type EntityResponseType = HttpResponse<IActionType>;
type EntityArrayResponseType = HttpResponse<IActionType[]>;

@Injectable({providedIn: 'root'})
export class ActionTypeService {
  public resourceUrl = SERVER_API_URL + 'api/action-types';

  constructor(protected http: HttpClient) {
  }

  create(actionType: IActionType): Observable<EntityResponseType> {
    return this.http.post<IActionType>(this.resourceUrl, actionType, {observe: 'response'});
  }

  update(actionType: IActionType): Observable<EntityResponseType> {
    return this.http.put<IActionType>(this.resourceUrl, actionType, {observe: 'response'});
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IActionType>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  queryByStep(step?: any): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<IActionType[]>(this.resourceUrl + '-step/' + step, {observe: 'response'});
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IActionType[]>(this.resourceUrl, {params: options, observe: 'response'});
  }

  queryForGetGeneral(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IActionType[]>(this.resourceUrl+'-general', {params: options, observe: 'response'});
  }

  getActionTypesListByRunSteps(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IActionType[]>(this.resourceUrl + '-run-step', {params: options, observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }
}
